import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
const indexUrl = Urls.PartnerUrl.indexList;
const getListUrl = Urls.TaskExcutionUrl.getListUrl;
const getStandarlineUrl =  Urls.TaskExcutionUrl.getStandarlineUrl;
export const createLoadingAction = createActionCreator(constant.ListLoading, loading => loading); // 流加载
export const createIndexListAction = createActionCreator(constant.INDEXLIST, list => list); // 通知列表
export const createIndexAdListAction = createActionCreator(constant.INDEXADLIST, list => list); // 通知列表
export const createAdLoadingAction = createActionCreator(constant.ListAdLoading, adloading => adloading); // 流加载
export const createStandarLineListAction = createActionCreator(constant.STANDARLINELIST, list => list); // 通知列表
export const createStandarLineListLoadingAction = createActionCreator(constant.STANDARLINELISTAdLoading, loading => loading); // 通知列表
// 获取hz列表
export const getIndexList = (param) => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(param);
            dispatch(createIndexListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};
//获取广告列表
export const getAdvertismentList = (param) => {
    return async (dispatch, getState) => {
        try {
            dispatch(createAdLoadingAction(true));
            let response = await request(param);
            dispatch(createIndexAdListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createAdLoadingAction(false));
        }
    };
};

export const getStandarlineList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createStandarLineListLoadingAction(true));
            let response = await request(getStandarlineUrl);
            dispatch(createStandarLineListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createStandarLineListLoadingAction(false));
        }
    };
}


export const getStandarlineTreeList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createStandarLineListLoadingAction(true));
            let response = await request(Urls.TaskExcutionUrl.getStandarlineTreeUrl);
            dispatch(createStandarLineListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createStandarLineListLoadingAction(false));
        }
    };
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/newExportData/actions.js